/* eslint-disable no-shadow */

// Vínculo da prestação do serviço (NFS-e Nacional). Confirmar valores com a equipe de backend.
export enum ServiceProvisionLinkEnum {
  SEM_VINCULO = 0,
  VINCULADO_CONTRATO = 1,
  VINCULADO_PROJETO = 2,
  VINCULADO_OUTROS = 3,
}

export const ServiceProvisionLinkLabels: Record<number, string> = {
  [ServiceProvisionLinkEnum.SEM_VINCULO]: "Sem vínculo",
  [ServiceProvisionLinkEnum.VINCULADO_CONTRATO]: "Vinculado a contrato",
  [ServiceProvisionLinkEnum.VINCULADO_PROJETO]: "Vinculado a projeto",
  [ServiceProvisionLinkEnum.VINCULADO_OUTROS]: "Outros vínculos",
};

export const ServiceProvisionLinkList = Object.keys(ServiceProvisionLinkLabels)
  .map(Number)
  .map((value) => ({ value, label: ServiceProvisionLinkLabels[value] }));
